import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactsComponent } from './contacts.component';
import { StoreModule } from '@ngrx/store';
import { contactsReducer } from './contacts.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ContactsEffects } from './contacts.effects';

import { TranslateModule } from '@ngx-translate/core';
import { contactsRoutes } from './contacts.routes';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import {
  MatButtonModule,
  MatRadioModule,
  MatSelectModule,
  MatIconModule,
  MatCheckboxModule,
  MatTableModule,
  MatSortModule,
  MatAutocompleteModule,
  MatInputModule
} from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ContactsTableComponent } from './contacts-table/contacts-table.component';
import { NgxDatatableModule } from '@acaisoft/ngx-datatable';
import { ContactsService } from './shared/services/contacts.service';
import { FiltersTagComponent } from './filters-tag/filters-tag.component';
import { FiltersSearchComponent } from './contact-filters/filters-search/filters-search.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { FiltersLayerComponent } from './contact-filters/filters-layer/filters-layer.component';
import { FilterUniversalComponent } from './contact-filters/filter-universal/filter-universal.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FilterCallLengthComponent } from './contact-filters/filter-call-length/filter-call-length.component';
import { FilterPhoneNumberComponent } from './contact-filters/filter-phone-number/filter-phone-number.component';
import { FilterService } from './shared/services/filter.service';
import { ContactsReports } from './reports/contacts.report';
import { ClickOutsideModule } from 'ng-click-outside';
import { localStorageSyncReducer } from './localStorageSyncReducer';
import { DomChangeDirective } from './contacts-table/dom-change-directive.directive';
import { EventsTableComponent } from './events-table/events-table.component';
import { DatePickerComponent } from '../shared/date-picker/date-picker.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { TagComponent } from './tag/tag.component';
import { RowTagsEditorComponent } from './row-tags-editor/row-tags-editor.component';
import { RowTagsEditorWrapperComponent } from './row-tags-editor-wrapper/row-tags-editor-wrapper.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxPermissionsModule } from 'ngx-permissions';
import { GetNumberModule } from '../get-number/get-number.module';
import { ContactTooltipComponent } from './shared/contact-tooltip/contact-tooltip.component';
import { TooltipModule } from 'ng2-tooltip-directive';

@NgModule({
  imports: [
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forChild(contactsRoutes),
    LayoutModule,
    MatButtonModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatTableModule,
    MatSortModule,
    MatAutocompleteModule,
    MatInputModule,
    NgxMatSelectSearchModule,
    TranslateModule,
    StoreModule.forFeature('contacts', contactsReducer, { metaReducers: [localStorageSyncReducer] }),
    EffectsModule.forFeature([ContactsEffects]),
    NgxDatatableModule,
    UiSwitchModule,
    BrowserModule,
    BrowserAnimationsModule,
    ClickOutsideModule,
    Daterangepicker,
    MatChipsModule,
    NgxPermissionsModule,
    MatDialogModule,
    GetNumberModule,
    TooltipModule
  ],
  providers: [ContactsService, FilterService, ContactsReports],
  declarations: [
    ContactsComponent,
    ContactsTableComponent,
    FiltersTagComponent,
    FiltersSearchComponent,
    FiltersLayerComponent,
    FilterUniversalComponent,
    FilterCallLengthComponent,
    FilterPhoneNumberComponent,
    DomChangeDirective,
    EventsTableComponent,
    TagComponent,
    RowTagsEditorComponent,
    RowTagsEditorWrapperComponent,
    ContactTooltipComponent
  ],
  exports: [ContactsComponent, FiltersTagComponent, TagComponent, RowTagsEditorComponent],
  entryComponents: [ContactsComponent]
})
export class ContactsModule {}
